import React from "react";
import { AdminPanelPage } from "../AdminPanelPage";
import { useLocalizedStrings } from "../../Localization";
import { AuditLogsDataTable } from "./components/AuditLogsDataTable";
import { useUserAllowed } from "../../Components/PermissionsUtil";
import { useAuditLogsConfig } from '../shared/hooks/useAdminPanelPageConfig';

export const AuditLogsPage = () => {
  const L = useLocalizedStrings();
  const isAdmin = useUserAllowed(["admin"]);

  // Fetch page configuration using the hook
  const {
    pageConfig,
    isLoading: isConfigLoading
  } = useAuditLogsConfig();

  return (
    <AdminPanelPage
      title={L.admin_panel.nav.audit_logs}
      description={L.admin_panel.audit_logs.description}
      breadcrumbs={[
        {
          label: L.admin_panel.nav.audit_logs,
        },
      ]}
    >
      {isAdmin ? (
        <AuditLogsDataTable
          pageConfig={pageConfig}
          isConfigLoading={isConfigLoading}
        />
      ) : null}
    </AdminPanelPage>
  );
};
